import React, { useEffect, useState } from "react";
import api from "../../api/api";
import {
  Box,
  Typography,
  Grid,
  CircularProgress,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const StudentInfoCard = () => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    api
      .get("/student-admission-detail/")
      .then((res) => {
        setInfo(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load student info:", err);
        setLoading(false);
      });
  }, []);

  if (loading) return <CircularProgress sx={{ mt: 5 }} />;

  const infoItems = [
    { label: "Full Name", value: info.full_name },
    { label: "Admission ID", value: info.id },
    { label: "Grade Class", value: info.grade_class },
    { label: "Division", value: info.division },
    { label: "Major Subject", value: info.major_subject },
    { label: "Date of Birth", value: info.date_of_birth },
    { label: "Hobit", value: info.hobit },
    { label: "Health Status", value: info.health_status },
    { label: "Address", value: info.address },
    { label: "Father's Name", value: info.father_name },
    { label: "Parent Name", value: info.parent_name },
    { label: "Parent Contact", value: info.parent_contact },
    { label: "Nationality", value: info.nationality },
    { label: "Status", value: info.status },
  ];

  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        maxWidth: "1000px",
        mx: "auto",
        mt: 4,
        backgroundColor: "#f5f5f5",
        borderRadius: "12px",
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        sx={{ mb: 2, color: "#1a1a1a" }}
      >
        About Me
      </Typography>

      <Divider sx={{ mb: 3, backgroundColor: "#bdbdbd" }} />

      <Grid container spacing={2}>
        {infoItems.map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                mb: 1.5,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 600,
                  color: "#4e342e", // Brown for label
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {item.label}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#1a1a1a",
                  fontSize: "1rem",
                  fontWeight: 500,
                  borderBottom: "1px solid #d3d3d3",
                  pb: 0.5,
                }}
              >
                {item.value || "—"}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ textAlign: "right", mt: 3 }}>
        <Typography variant="caption" sx={{ color: "#888" }}>
          Excellent Kids Foundation
        </Typography>
      </Box>
    </Box>
  );
};

export default StudentInfoCard;



// // StudentInfoSection.js
// import React, { useEffect, useState } from "react";
// import api from "../../api/api";
// import {
//   Box,
//   Typography,
//   Grid,
//   CircularProgress,
//   Paper,
//   Divider,
// } from "@mui/material";

// const StudentInfoSection = () => {
//   const [info, setInfo] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     api
//       .get("/student-admission-detail/")
//       .then((res) => {
//         setInfo(res.data);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Failed to load student info:", err);
//         setLoading(false);
//       });
//   }, []);

//   if (loading) return <CircularProgress sx={{ mt: 5 }} />;

//   const infoItems = [
//     { label: "Parent Name", value: info.parent_name },
//     { label: "Grade Class", value: info.grade_class },
//     { label: "Division", value: info.division },
//     { label: "Major Subject", value: info.major_subject },
//     { label: "Hobit", value: info.hobit },
//     { label: "Date of Birth", value: info.date_of_birth },
//     { label: "Address", value: info.address },
//     { label: "Mother's Name", value: info.mother_name },
//     { label: "Father's Name", value: info.father_name },
//     { label: "Health Status", value: info.health_status },
//     { label: "Parent Contact", value: info.parent_contact },
//     { label: "Status", value: info.status },
//     { label: "Nationality", value: info.nationality },
//   ];

//   return (
//     <Paper
//       elevation={3}
//       sx={{
//         p: 4,
//         mt: 3,
//         borderRadius: "16px",
//         background: "#f8f9fa",
//         border: "1px solid #e0e0e0",
//       }}
//     >
//       <Typography
//         variant="h5"
//         fontWeight="bold"
//         gutterBottom
//         sx={{ color: "#333", mb: 2 }}
//       >
//         Student Profile
//       </Typography>
//       <Divider sx={{ mb: 3 }} />

//       <Grid container spacing={3}>
//         {infoItems.map((item, index) => (
//           <Grid item xs={12} sm={6} md={4} key={index}>
//             <Box
//               sx={{
//                 background: "#ffffff",
//                 borderRadius: "12px",
//                 p: 2,
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
//                 borderLeft: "4px solid #1976d2",
//               }}
//             >
//               <Typography
//                 variant="body2"
//                 fontWeight="bold"
//                 sx={{ color: "#555" }}
//               >
//                 {item.label}
//               </Typography>
//               <Typography variant="subtitle1" sx={{ color: "#111", mt: 0.5 }}>
//                 {item.value}
//               </Typography>
//             </Box>
//           </Grid>
//         ))}
//       </Grid>
//     </Paper>
//   );
// };

// export default StudentInfoSection;
